import { render, staticRenderFns } from "./NewsItemM.vue?vue&type=template&id=8b4dc8e4&scoped=true"
import script from "./NewsItemM.vue?vue&type=script&lang=ts"
export * from "./NewsItemM.vue?vue&type=script&lang=ts"
import style0 from "./NewsItemM.vue?vue&type=style&index=0&id=8b4dc8e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4dc8e4",
  null
  
)

export default component.exports